import {BaseService} from './Core/BaseService';

class ActivityFeedSubscriptionService extends BaseService {
    get Url() { return super.Url + "/activityFeedSubscriptions"; }

    GetActivityFeedSubscriptions() {
        return this.SendRequest(BaseService.GET);
    }

    GetActivityFeedSubscriptionsForContextNodeId(contextNodeId) {
        let request = {contextNodeId: contextNodeId};

        return this.SendRequest(BaseService.GET, request);
    }

    GetActivityFeedSubscription(id) {
        return this.SendRequest(BaseService.GET, id);
    }

    UpdateActivityFeedSubscriptions(data) {
        return this.SendRequest(BaseService.PUT, data);
    }

    CreateActivityFeedSubscription(contextNodeId, activityFeedFilterId) {
        let request = {contextNodeId: contextNodeId};

        if(activityFeedFilterId) {
            request['activityFeedFilterId'] = activityFeedFilterId;
        }

        return this.SendRequest(BaseService.POST, request);
    }

    DeleteActivityFeedSubscription(id) {
        return this.SendRequest(BaseService.DELETE, id);
    }
}

export const service = new ActivityFeedSubscriptionService();

